<template>
    <div class="subject-list">
        <ul>
            <li v-for="(grade,index) in list" :key="index">
                <a :href="grade.link">
                    <span v-if="grade.gradeName !== ''">{{grade.gradeName}}</span>
                    <img v-if="grade.gradeName !== ''" src="../../../../assets/images/grade_bg.png" alt="">
                    <img v-else :src="grade.image" alt="">
                </a>
            </li>
        </ul>    
    </div>
</template>

<script>

export default{
    name: 'Subject',
    props:{
        list: Array    
    }
}
</script>

<style lang="less" scoped>
    .subject-list{
        overflow: hidden;
        li{
            width: 50%;
            float: left;
            text-align: center;
            margin-bottom: 0.4rem;
            a{
                display: block;
                position: relative;
            }
            span{
                display: block;
                position: absolute;
                font-size: 0.6rem;
                color: #fff;
                font-weight: bold;
                left: 0.6rem;
                top: 0.3rem;
            }
            img{
                width: 90%;
            }
        }
    }             
</style>   